import { Orders } from '@grandvisionhq/api-client';

/**
 * Backend response from api-client is an enum value
 * The FE wants to use string constants for easier checks and handling
 *
 * This abstraction also makes it possible to migrate to grapqhl later on
 */ const mapPaymentState = (paymentState)=>{
    switch(paymentState.paymentState){
        case Orders.PaymentState.Pending:
            return 'Pending';
        case Orders.PaymentState.Paid:
            return 'Paid';
        case Orders.PaymentState.Failed:
            return 'Failed';
        case Orders.PaymentState.BalanceDue:
            return 'BalanceDue';
        case Orders.PaymentState.CreditOwed:
            return 'CreditOwed';
        default:
            return undefined;
    }
};

export { mapPaymentState };
//# sourceMappingURL=payment-state.js.map
